<template>
  <footer class="container">
    <div class="container__inner footer__inner">
      <a class="fun" href="https://www.fun.ac.jp/" target="_blank" rel="noopener noreferrer">
        <img src="../../../assets/Top/funLogo.svg" alt="公立はこだて未来大学">
      </a>
      <p class="copyright">©️2019 公立はこだて未来大学
        <br>情報デザインコース
      </p>
    </div>
    <div class="linkTab">
      <router-link class="linkTab__item" exact-active-class="active" to="/">
        <font-awesome-icon icon="home"/>
      </router-link>
      <router-link class="linkTab__item" exact-active-class="active" to="/hakodate">函館展</router-link>
      <router-link class="linkTab__item" exact-active-class="active" to="/tokyo">東京展</router-link>
      <router-link class="linkTab__item" exact-active-class="active" to="/exhibits">研究内容</router-link>
      <!-- <router-link class="linkItem" exact-active-class="active" to="/404">展示作品</router-link> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'o-Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$blue: #009898;
$thin-yellow: #f2e680;

.container {
  margin: 0;
  padding: 40px 0;
  box-shadow: 0 0 15px -5px rgba(0, 0, 0, 0.8);
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin: 0 0 52px;
  }
  @media screen and (max-width: 411px) {
    margin: 0 0 52px;
  }
}

.fun {
  display: block;
  width: 280px;
  margin-left: auto;
  img {
    width: 100%;
  }
  @media screen and (max-width: 411px) {
    width: 200px;
    margin: 0 auto;
  }
}

.copyright {
  margin-top: 24px;
  font-size: 12px;
  text-align: right;
  line-height: 1.5;
  br {
    display: none;
  }
  @media screen and (max-width: 411px) {
    margin-top: 24px;
    font-size: 12px;
    text-align: center;
    br {
      display: block;
    }
  }
}

.linkTab {
  position: fixed;
  bottom: 0;
  left: 0;
  display: none;
  flex-wrap: no-wrap;
  width: 100%;
  border-top: solid 2px $blue;
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 8px;
    background-color: $white;
    color: $blue;
    font-weight: 900;
    text-decoration: none;
    text-align: center;
    transition: all 0.2s ease-out;
    &:first-child {
      width: 80px;
      img {
        display: block;
        width: 100%;
      }
    }
    &:not(:first-child) {
      width: 100%;
      position: relative;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        width: 1px;
        height: 100%;
        background-color: $blue;
      }
    }
    &.active {
      background-color: $thin-yellow;
    }
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    display: flex;
  }
  @media screen and (max-width: 411px) {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Footer/index.vue